<!-- toggle buttons -->
<div id="panel-toggle">
    <button 
        class="icon-button" 
        (click)="toggle('optionsOpen')" 
        [ngClass]="{active: optionsOpen}"
        [disabled]="joyride.isOpen">
        <mat-icon>settings_cell</mat-icon> 
    </button>
    <button 
        [joyrideStep]="joyrideSteps.step5"
        class="icon-button" 
        (click)="toggle('imagesOpen')" 
        [ngClass]="{active: imagesOpen}"
        [disabled]="joyride.isOpen">
        <mat-icon>insert_photo</mat-icon> 
    </button>
</div>
<div
    [joyrideStep]="[joyrideSteps.step1, joyrideSteps.stepNoSite, joyrideSteps.step6]"
    class="preview-wrap {{selectedDevice}} {{sites.length && (loading === true || firstLoad === false) ? 'loading' : ''}} {{optionsOpen && imagesOpen ? 'split' : ''}}" 
    #previewWrapEl>
    <div class="device-container">
        <div class="device-skin" #deviceSkinEl>
            <div class="device-wrap">
                <div class="content-overlay">
                    <img *ngIf="sites.length && (loading === true || firstLoad === false)" class="loader" src="/wp-content/themes/swarm/app/assets/images/loading.gif">
                </div>         
                <div class="frame-wrap">
                    <div class="overlay">
                        <ng-container *ngFor="let btn of editButtons; trackBy: utils.trackByIndex">
                            <button 
                                *ngIf="btn.index !== 2 && btn.index !== 3; else joyrideBtnEls"
                                type="button"
                                (click)="editClick(btn)"
                                (mouseover)="editMouseOver(btn)"
                                (mouseleave)="editMouseLeave()"
                                [ngStyle]="btn.styles">
                                <mat-icon>create</mat-icon>
                            </button>
                            <ng-template #joyrideBtnEls>
                                <button 
                                    *ngIf="btn.index == 2"
                                    [joyrideStep]="joyrideSteps.step3"
                                    type="button"
                                    (click)="editClick(btn)"
                                    (mouseover)="editMouseOver(btn)"
                                    (mouseleave)="editMouseLeave()"
                                    [ngStyle]="btn.styles">
                                    <mat-icon>create</mat-icon>
                                </button>
                                <button 
                                    *ngIf="btn.index == 3"
                                    [joyrideStep]="joyrideSteps.step4"
                                    type="button"
                                    (click)="editClick(btn)"
                                    (mouseover)="editMouseOver(btn)"
                                    (mouseleave)="editMouseLeave()"
                                    [ngStyle]="btn.styles">
                                    <mat-icon>create</mat-icon>
                                </button>
                            </ng-template>
                        </ng-container>
                    </div>
                    <iframe 
                        *ngIf="sites.length; else previewContentEl"
                        sandbox="allow-same-origin allow-scripts" 
                        #iframeEl 
                        id="previewIframe" 
                        name="previewIframe" 
                        scrolling="no" 
                        frameborder="0" 
                        autosizeIframe
                        (resize)="iframeResize($event)"
                        (load)="iframeLoaded()">
                        <p>There was an error loading the preview.</p>
                    </iframe>
                    <ng-template #previewContentEl>
                        <article #articleEl [device]="selectedDevice"></article>
                    </ng-template>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- toggle panel -->
<div id="panel-options" [ngClass]="{split: imagesOpen && optionsOpen, open: imagesOpen || optionsOpen}">
    <div class="wrap">
        <!-- preview options -->
        <div class="inner {{ optionsOpen ? 'open' : '' }}">
            <div id="preview-switcher">
                <div class="title">
                    <mat-icon>settings_cell</mat-icon> Preview Settings <button type="button" class="help" (click)="runJoyride()"><mat-icon>help_outline</mat-icon></button>
                </div>
                <div class="inner-wrap">
                    <div [joyrideStep]="joyrideSteps.stepDevice" class="section">
                        <label id="device">Device</label>
                        <mat-radio-group
                            aria-labelledby="device"
                            [(ngModel)]="selectedDevice"
                            (change)="setDevice()">
                            <mat-radio-button [disabled]="joyride.isOpen && disableDeviceOptions" *ngFor="let device of devices; trackBy: utils.trackByIndex" [value]="device">
                                {{device}}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
            
                    <div class="section">
                        <label id="page">Page</label>
                        <mat-radio-group
                            aria-labelledby="page"
                            [(ngModel)]="selectedPage"
                            (change)="optionChange()">
                            <ng-container *ngFor="let page of pages; trackBy: utils.trackByIndex">
                                <mat-radio-button 
                                    *ngIf="page !== 'home'; else homeToggleBtn"
                                    [value]="page"
                                    [disabled]="joyride.isOpen">
                                    {{page}}
                                </mat-radio-button>
                                <ng-template #homeToggleBtn>
                                    <mat-radio-button 
                                        [joyrideStep]="joyrideSteps.step2"
                                        [value]="page"
                                        [disabled]="joyride.isOpen || !selectedSite || !slideshow.getFeaturedImage()">
                                        {{page}}
                                    </mat-radio-button>
                                </ng-template>
                            </ng-container>
                        </mat-radio-group>
                    </div>
            
                    <div [joyrideStep]="joyrideSteps.stepSites" class="section">
                        <label id="property">Property</label>
                        <div class="overflow">
                            <mat-radio-group
                                aria-labelledby="property"
                                [(ngModel)]="selectedSite"
                                (change)="optionChange()">
                                <mat-radio-button 
                                    *ngFor="let site of sites; trackBy: utils.trackByIndex" 
                                    [value]="site" 
                                    [title]="site.domain"
                                    [disabled]="joyride.isOpen && disableSiteOptions">
                                    {{site.domain}}
                                </mat-radio-button>
                            </mat-radio-group>
                            <div *ngIf="sites.length == 0">Select a site on the meta tab</div>
                        </div>
                    </div>
                </div>
                
            </div> 
        </div>

        <!-- images -->
        <image-list [joyrideStep]="joyrideSteps.stepNoImage" class="inner {{ imagesOpen ? 'open' : '' }}"></image-list>
    </div>
</div>